<template>
  <v-col cols="12" :class="`px-0 ${computedParameters.length > 0 ? 'pb-7' : ''}`">
    <card-title-row
      :has-icon-column="false"
      is-subtitle
      translation-path="sidebar.additionalExportParameters"
      :amount="1"
      :is-plural="true"
    >
      <template #subtitle>
        <italic-subheader
          style="text-align: left; max-width: 20vw"
          translation-path="sidebar.addAdditionalParameters"
        ></italic-subheader>
      </template>
      <template #buttons>
        <base-rounded-button icon="mdi-plus" size="x-small" color="success" @click="addNew" />
      </template>
    </card-title-row>
    <v-list v-if="computedParameters.length > 0" class="py-0 rounded-lg elevation-4" dense>
      <v-list-item
        v-for="(parameterData, index) in computedParameters"
        :key="parameterData.id"
        class="graph-generation-params-element hover-list-element"
      >
        <v-list-item-content style="padding: 0.4rem 0">
          <v-list-item-title class="text-body-2">
            <v-row no-gutters class="flex-nowrap" align="center">
              <v-col cols="auto" style="max-width: 50%">
                <v-checkbox v-model="parameterData.checked" :hide-details="true" :ripple="false"></v-checkbox>
              </v-col>
              <v-col cols="7">
                <v-row no-gutters class="flex-col">
                  <v-col cols="12" class="text-left">
                    <v-tooltip bottom color="font" max-width="300">
                      <template #activator="{ on }">
                        <div class="text-body-2 text-truncate" v-on="on">
                          {{ parameterData.name }}
                        </div>
                      </template>
                      <div style="word-break: break-all;">
                        {{ parameterData.name }}
                      </div>
                    </v-tooltip>
                  </v-col>
                  <v-col cols="12">
                    <italic-subheader
                      :straight-text="
                        `${$i18n.t('sidebar.graphGenerationParameters.parameterDataSource')}: ${
                          dataSourcesMetadata[parameterData.datasource].verbose_name
                        }`
                      "
                      style="font-size: 10px !important;"
                    >
                    </italic-subheader>
                  </v-col>
                </v-row>
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="auto" style="max-width: 20%">
                <v-row no-gutters align="center">
                  <v-col cols="auto">
                    <dots-menu
                      @delete="toggleDelete(parameterData, index)"
                      @edit="toggleEdit(parameterData, index)"
                      :items="dotsItems"
                      font-size="19px"
                    />
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <main-dialog
      v-if="isDeletingLoaded"
      :is-visible.sync="isDeletingVisible"
      :title="$i18n.t('sidebar.graphGenerationParameters.deleteParameterTitle')"
      :body="$i18n.t('sidebar.graphGenerationParameters.deleteParameterAgree', { name: deletingParameter.name })"
      agree-text="dialog.agreeDelete"
      @agree="handleDelete"
    />
    <graph-generation-params-dialog
      v-if="isEditDialogLoaded"
      :is-visible.sync="isEditDialogVisible"
      :parameters.sync="computedParameters"
      :parameter-data="currentParameter"
      :parameter-index="parameterIndex"
    />
  </v-col>
</template>

<script>
import DotsMenu from '@/components/DotsMenu';
import CardTitleRow from '@/components/CardTitleRow';
import ItalicSubheader from '@/components/ItalicSubheader';

import { get } from 'vuex-pathify';

export default {
  name: 'GraphGenerationParamsList',
  components: {
    DotsMenu,
    CardTitleRow,
    ItalicSubheader,
    MainDialog: () => import('@/components/MainDialog'),
    GraphGenerationParamsDialog: () => import('@/components/GraphGenerationParamsDialog'),
  },
  props: {
    parameters: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  data: () => ({
    dotsItems: [{ name: 'edit' }, { name: 'delete' }],
    currentParameter: undefined,
    deletingParameter: undefined,
    parameterIndex: undefined,
    isDeletingVisible: false,
    isDeletingLoaded: false,
    isEditDialogVisible: false,
    isEditDialogLoaded: false,
  }),
  computed: {
    dataSourcesMetadata: get('layers/metadata'),
    computedParameters: {
      get() {
        return this.parameters;
      },
      set(nV) {
        this.$emit('update:parameters', nV);
      },
    },
  },
  methods: {
    addNew() {
      this.currentParameter = null;
      this.isEditDialogLoaded = true;
      this.isEditDialogVisible = true;
    },
    toggleDelete(parameterData, index) {
      this.deletingParameter = parameterData;
      this.parameterIndex = index;
      this.isDeletingLoaded = true;
      this.isDeletingVisible = true;
    },
    handleDelete() {
      this.isDeletingLoaded = false;
      this.isDeletingVisible = false;
      let paramsList = [...this.computedParameters];
      paramsList.splice(this.parameterIndex, 1);
      this.computedParameters = paramsList;
    },
    toggleEdit(parameterData, index) {
      this.parameterIndex = index;
      this.currentParameter = JSON.parse(JSON.stringify(parameterData));
      this.isEditDialogLoaded = true;
      this.isEditDialogVisible = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.graph-generation-params-element {
  @include border(bottom);
  text-align: left;
}
.graph-generation-params-list {
  border-radius: 4px;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25), 0px -1px 0px rgba(0, 0, 0, 0.15) !important;
}
.graph-generation-params-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
::v-deep .v-input--selection-controls {
  padding: 0 !important;
}
</style>
